import { render, staticRenderFns } from "./OutOfDushOrdersSettings.vue?vue&type=template&id=7898f9c0&scoped=true&"
import script from "./OutOfDushOrdersSettings.vue?vue&type=script&lang=ts&"
export * from "./OutOfDushOrdersSettings.vue?vue&type=script&lang=ts&"
import style0 from "./OutOfDushOrdersSettings.vue?vue&type=style&index=0&id=7898f9c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7898f9c0",
  null
  
)

export default component.exports